import React, { FC, useMemo } from 'react';
import { Button, Form, Input, Modal } from 'antd';

const FORM_NAME = 'group-title-form';
const AddOrEditGroupTitleModal: FC<any> = ({
	groupTitle,
	onCancel,
	onSubmit,
	saving,
}): React.ReactElement => {
	const isUpdate = useMemo(() => !!groupTitle, [groupTitle]);
	return (
		<Modal
			visible={true}
			width={600}
			title={`${isUpdate ? 'Change Group Title' : 'Add Group'}`}
			onCancel={onCancel}
			closable={false}
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_NAME}
					loading={saving}
				>
					{isUpdate ? 'Update' : 'Create'}
				</Button>,
			]}
		>
			<Form id={FORM_NAME} layout="vertical" onFinish={onSubmit}>
				<Form.Item
					name="groupTitle"
					initialValue={groupTitle}
					label="Title"
					rules={[
						{
							required: true,
							message: 'Please enter a valid title.',
						},
					]}
				>
					<Input style={{ width: '100%' }} />
				</Form.Item>
			</Form>
		</Modal>
	);
};
export default AddOrEditGroupTitleModal;
